<template>
    <BFormGroup label="ОПИС">
        <QuillEditor
            v-model:content="protocol.description"
            contentType="html"
            theme="snow"
            :toolbar="toolbar"
            placeholder="Введіть опис…"
            class="tender-editor"
        />
    </BFormGroup>
</template>

<script>
import {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
} from 'bootstrap-vue-next';
import { QuillEditor } from '@vueup/vue-quill';
export default {
    name: "protocol_description",
    props : {
        protocol : {
            type : Object
        }
    },
    
    data() {
        return {
            is_load: false,
            toolbar: [
                ['bold', 'italic', 'underline', 'link'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                ['clean'] // по желанию (ластик)
            ]
        }
    },
    
    
    components : {
        BForm,
        BFormGroup,
        BFormInput,
        QuillEditor,
        BButton,
    }
}
</script>



<style scoped>

</style>